import React, { useState, useRef, useEffect } from "react";
import { Send, Bot } from "lucide-react";
import { api } from "../../services/api";

const SUGGESTIONS = ["Combien de commandes ?", "Chiffre d'affaires", "Bons en retard", "Nombre de clients", "Prix de l'huile"];

const WhatsAppIA = () => {
  const [messages, setMessages] = useState([
    { from: "bot", text: "Bonjour 👋 Je suis l'assistant IA de Ssuq. Posez-moi une question sur vos commandes, ventes, bons de commande, produits ou clients." }
  ]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const endRef = useRef(null);
  const sessionId = useRef("admin-" + Math.random().toString(36).slice(2, 8));

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, typing]);

  const send = async (textArg) => {
    const text = (textArg ?? input).trim();
    if (!text || typing) return;
    setMessages((m) => [...m, { from: "user", text }]);
    setInput("");
    setTyping(true);
    try {
      const res = await api.aiChat(text, sessionId.current);
      setMessages((m) => [...m, { from: "bot", text: res.reply }]);
    } catch (e) {
      setMessages((m) => [...m, { from: "bot", text: "Assistant momentanément indisponible. Réessayez dans un instant." }]);
    } finally {
      setTyping(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm bg-white flex flex-col" style={{ height: "70vh" }}>
        <div className="bg-[#075E54] text-white px-5 py-3 flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-[#25D366] flex items-center justify-center"><Bot size={20} /></div>
          <div>
            <div className="font-display font-bold">Assistant IA Ssuq</div>
            <div className="text-white/70 text-xs">En ligne · propulsé par IA</div>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-3" style={{ background: "#ECE5DD" }}>
          {messages.map((m, i) => (
            <div key={i} className={`flex ${m.from === "user" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[78%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed shadow-sm whitespace-pre-wrap ${m.from === "user" ? "bg-[#DCF8C6] text-navy-900 rounded-br-sm" : "bg-white text-navy-900 rounded-bl-sm"}`}>
                {m.text}
              </div>
            </div>
          ))}
          {typing && <div className="flex justify-start"><div className="bg-white rounded-2xl px-4 py-3 shadow-sm text-gray-400 text-sm">…</div></div>}
          <div ref={endRef} />
        </div>

        <div className="px-3 py-2 flex gap-2 flex-wrap border-t border-gray-100 bg-white">
          {SUGGESTIONS.map((s) => (
            <button key={s} onClick={() => send(s)} className="text-xs font-display font-semibold text-[#075E54] bg-[#25D366]/10 hover:bg-[#25D366]/20 rounded-full px-3 py-1.5 transition">{s}</button>
          ))}
        </div>

        <form onSubmit={(e) => { e.preventDefault(); send(); }} className="p-3 flex items-center gap-2 bg-white border-t border-gray-100">
          <input value={input} onChange={(e) => setInput(e.target.value)} placeholder="Écrivez un message…"
            className="flex-1 px-4 py-2.5 rounded-full border border-gray-200 focus:border-[#25D366] focus:ring-2 focus:ring-[#25D366]/20 outline-none text-sm" />
          <button type="submit" className="w-11 h-11 rounded-full bg-[#25D366] text-white flex items-center justify-center hover:brightness-95 transition shrink-0"><Send size={18} /></button>
        </form>
      </div>
      <p className="text-xs text-gray-400 mt-3">Assistant IA connecté aux données réelles de la plateforme (commandes, produits, clients).</p>
    </div>
  );
};

export default WhatsAppIA;
